<script setup lang="ts">

import { computed } from 'vue'
import { adminOptions } from "@/pages/app/administration/menus/adminOptions";
import AppNavBar from "@/components/Menu/AppMenuBar.vue";
import { useUser } from '@/composables/useUser';

const { user } = useUser()

const visibleOptions = computed(() => {
  return adminOptions.filter((opt) => {
    if (!opt.roles || opt.roles.length === 0) return true
    return user.roles?.some((role: string) => opt.roles!.includes(role))
  })
})

</script>


<template>
  <AppNavBar :buttons="visibleOptions" />
</template>

<style scoped>
nav {
  @apply h-16 min-h-16 max-h-16; /* Prevents squishing */
}
</style>
